"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8155],{

/***/ 16983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IconArrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96937);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51776);



const IconArrow = ({ size =20 , color ="#19093A" , direction ="left" , isCaret =false , isCircle =false , className ="fill-violet_main_to_dark_purple_surface" , customClassName =""  })=>{
    const theme = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__/* .useSystemStore */ .m)((state)=>state.theme);
    switch(direction){
        case "left":
            className = "rotate-180";
            break;
        case "bottom":
            className = "rotate-90";
            break;
        case "up":
            className = "-rotate-90";
            break;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className + " " + customClassName,
        width: size,
        height: size,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: isCaret ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M15.5397 11.2895L9.87974 5.63955C9.78677 5.54582 9.67617 5.47143 9.55431 5.42066C9.43246 5.36989 9.30175 5.34375 9.16974 5.34375C9.03773 5.34375 8.90702 5.36989 8.78516 5.42066C8.6633 5.47143 8.5527 5.54582 8.45974 5.63955C8.27349 5.82691 8.16895 6.08036 8.16895 6.34455C8.16895 6.60873 8.27349 6.86219 8.45974 7.04955L13.4097 12.0495L8.45974 16.9995C8.27349 17.1869 8.16895 17.4404 8.16895 17.7045C8.16895 17.9687 8.27349 18.2222 8.45974 18.4095C8.55235 18.504 8.6628 18.5792 8.78467 18.6307C8.90655 18.6822 9.03743 18.709 9.16974 18.7095C9.30204 18.709 9.43293 18.6822 9.5548 18.6307C9.67668 18.5792 9.78712 18.504 9.87974 18.4095L15.5397 12.7595C15.6412 12.6659 15.7223 12.5523 15.7777 12.4258C15.8331 12.2993 15.8617 12.1627 15.8617 12.0245C15.8617 11.8864 15.8331 11.7498 15.7777 11.6233C15.7223 11.4968 15.6412 11.3832 15.5397 11.2895Z",
            fill: theme == "dark" ? "#C29FEE" : color
        }) : isCircle ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.86 12.5269L11.0867 8.76019C11.0247 8.6977 10.951 8.64811 10.8697 8.61426C10.7885 8.58041 10.7014 8.56299 10.6134 8.56299C10.5254 8.56299 10.4382 8.58041 10.357 8.61426C10.2757 8.64811 10.202 8.6977 10.14 8.76019C10.0159 8.8851 9.94617 9.05406 9.94617 9.23019C9.94617 9.40631 10.0159 9.57528 10.14 9.70019L13.44 13.0335L10.14 16.3335C10.0159 16.4584 9.94617 16.6274 9.94617 16.8035C9.94617 16.9796 10.0159 17.1486 10.14 17.2735C10.2018 17.3365 10.2754 17.3866 10.3567 17.421C10.4379 17.4553 10.5252 17.4732 10.6134 17.4735C10.7016 17.4732 10.7888 17.4553 10.8701 17.421C10.9513 17.3866 11.025 17.3365 11.0867 17.2735L14.86 13.5069C14.9277 13.4444 14.9817 13.3687 15.0186 13.2843C15.0556 13.2 15.0747 13.1089 15.0747 13.0169C15.0747 12.9248 15.0556 12.8337 15.0186 12.7494C14.9817 12.665 14.9277 12.5893 14.86 12.5269Z",
            fill: theme == "dark" ? "#C29FEE" : color
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4.16272 9.1706L4.16277 9.0706L4.16291 9.0706C4.16298 9.0706 4.16306 9.0706 4.16313 9.0706L14.4442 9.07631L11.0153 5.64742C10.8416 5.47376 10.7441 5.23823 10.7441 4.99264C10.7441 4.74705 10.8416 4.51152 11.0153 4.33786C11.1889 4.1642 11.4245 4.06665 11.6701 4.06665C11.9156 4.06665 12.1512 4.16421 12.3248 4.33786L17.3322 9.3452L17.333 9.34606L17.333 9.34606C17.4174 9.43255 17.4841 9.53473 17.5293 9.64683C17.6226 9.87302 17.6226 10.1269 17.5293 10.3531C17.4841 10.4652 17.4174 10.5674 17.333 10.6539L17.3322 10.6548L17.3322 10.6548L12.3248 15.6621C12.1512 15.8358 11.9156 15.9333 11.6701 15.9333C11.4245 15.9333 11.1889 15.8358 11.0153 15.6621C10.8416 15.4884 10.7441 15.2529 10.7441 15.0073C10.7441 14.7617 10.8416 14.5262 11.0153 14.3525L14.4442 10.9236L4.16313 10.9294C4.16306 10.9294 4.16298 10.9294 4.16291 10.9294L4.16278 10.9294L4.16272 10.8294C4.05368 10.8298 3.94563 10.8087 3.8448 10.7671C3.74398 10.7256 3.65237 10.6645 3.57527 10.5874C3.49816 10.5103 3.43709 10.4187 3.39557 10.3179C3.35405 10.2171 3.3329 10.109 3.33335 9.99998M4.16272 9.1706C4.05368 9.17016 3.94563 9.1913 3.8448 9.23282C3.74398 9.27435 3.65237 9.33542 3.57527 9.41252C3.49816 9.48963 3.43709 9.58124 3.39557 9.68206C3.35405 9.78289 3.3329 9.89094 3.33335 9.99998M4.16272 9.1706L14.5442 9.17637L4.16272 9.1706ZM3.33335 9.99998L3.23335 9.99957C3.23335 9.9997 3.23334 9.99984 3.23334 9.99998C3.23334 10.0001 3.23335 10.0002 3.23335 10.0004L3.33335 9.99998Z",
            fill: theme == "dark" ? "#C29FEE" : color,
            stroke: color,
            strokeWidth: "0.2"
        })
    });
};


/***/ }),

/***/ 88038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ IconFilter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96937);


const IconFilter = ({ size =20 , color ="#19093A" , className ="fill-purple80_to_white"  })=>{
    const theme = (0,components_PageHeader_systemStore__WEBPACK_IMPORTED_MODULE_1__/* .useSystemStore */ .m)((state)=>state.theme);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        // fill={color}
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Frame",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Vector",
                d: "M7 4H13.5M7 4C7 4.26522 6.89464 4.51957 6.70711 4.70711C6.51957 4.89464 6.26522 5 6 5C5.73478 5 5.48043 4.89464 5.29289 4.70711C5.10536 4.51957 5 4.26522 5 4M7 4C7 3.73478 6.89464 3.48043 6.70711 3.29289C6.51957 3.10536 6.26522 3 6 3C5.73478 3 5.48043 3.10536 5.29289 3.29289C5.10536 3.48043 5 3.73478 5 4M5 4H2.5M7 12H13.5M7 12C7 12.2652 6.89464 12.5196 6.70711 12.7071C6.51957 12.8946 6.26522 13 6 13C5.73478 13 5.48043 12.8946 5.29289 12.7071C5.10536 12.5196 5 12.2652 5 12M7 12C7 11.7348 6.89464 11.4804 6.70711 11.2929C6.51957 11.1054 6.26522 11 6 11C5.73478 11 5.48043 11.1054 5.29289 11.2929C5.10536 11.4804 5 11.7348 5 12M5 12H2.5M11 8H13.5M11 8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9C9.73478 9 9.48043 8.89464 9.29289 8.70711C9.10536 8.51957 9 8.26522 9 8M11 8C11 7.73478 10.8946 7.48043 10.7071 7.29289C10.5196 7.10536 10.2652 7 10 7C9.73478 7 9.48043 7.10536 9.29289 7.29289C9.10536 7.48043 9 7.73478 9 8M9 8H2.5",
                stroke: theme == "dark" ? "#C29FEE" : "#883CFF",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
};


/***/ }),

/***/ 94981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ IconShare; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);


// 817E8C
// 19093A
const IconShare = ({ size =24 , color ="#5D586C"  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.0013 12.9807C15.4107 12.9846 14.8282 13.1191 14.2959 13.3746C13.7635 13.6301 13.2944 14.0002 12.9223 14.4583L7.82395 12.1121C8.06366 11.379 8.06366 10.5888 7.82395 9.85574L12.9223 7.50954C13.5237 8.23433 14.3622 8.72365 15.2897 8.89114C16.2172 9.05863 17.1741 8.89352 17.9916 8.42496C18.8091 7.95639 19.4345 7.21449 19.7576 6.33019C20.0807 5.44588 20.0806 4.47602 19.7574 3.59178C19.4341 2.70753 18.8085 1.96574 17.991 1.49733C17.1734 1.02891 16.2164 0.863976 15.289 1.03163C14.3615 1.19929 13.5231 1.68877 12.9218 2.41367C12.3205 3.13857 11.995 4.0523 12.0026 4.9936C12.0056 5.23145 12.029 5.4686 12.0726 5.70246L6.79429 8.12853C6.23155 7.579 5.51895 7.20754 4.74576 7.06069C3.97257 6.91384 3.17319 6.99813 2.44775 7.303C1.72232 7.60787 1.1031 8.11977 0.667681 8.77455C0.23226 9.42933 0 10.1979 0 10.9839C0 11.7699 0.23226 12.5385 0.667681 13.1933C1.1031 13.8481 1.72232 14.36 2.44775 14.6648C3.17319 14.9697 3.97257 15.054 4.74576 14.9071C5.51895 14.7603 6.23155 14.3888 6.79429 13.8393L12.0726 16.2654C12.029 16.4992 12.0056 16.7364 12.0026 16.9742C12.0026 17.7641 12.2371 18.5362 12.6765 19.1929C13.1159 19.8497 13.7404 20.3615 14.4711 20.6638C15.2017 20.966 16.0057 21.0451 16.7814 20.891C17.5571 20.7369 18.2696 20.3566 18.8288 19.7981C19.388 19.2396 19.7689 18.528 19.9232 17.7533C20.0775 16.9787 19.9983 16.1757 19.6956 15.446C19.393 14.7162 18.8804 14.0925 18.2229 13.6537C17.5653 13.2149 16.7922 12.9807 16.0013 12.9807ZM16.0013 2.99683C16.3967 2.99683 16.7833 3.11394 17.1121 3.33335C17.4409 3.55276 17.6971 3.86461 17.8485 4.22947C17.9998 4.59434 18.0394 4.99582 17.9622 5.38315C17.8851 5.77049 17.6947 6.12628 17.4151 6.40553C17.1354 6.68479 16.7792 6.87496 16.3914 6.95201C16.0035 7.02905 15.6015 6.98951 15.2362 6.83838C14.8708 6.68725 14.5586 6.43132 14.3389 6.10295C14.1192 5.77458 14.0019 5.38853 14.0019 4.9936C14.0019 4.46403 14.2126 3.95614 14.5875 3.58167C14.9625 3.20721 15.471 2.99683 16.0013 2.99683ZM4.0052 12.9807C3.60976 12.9807 3.22321 12.8636 2.89442 12.6442C2.56563 12.4248 2.30936 12.1129 2.15804 11.748C2.00671 11.3832 1.96712 10.9817 2.04426 10.5944C2.12141 10.207 2.31183 9.85124 2.59144 9.57199C2.87106 9.29273 3.22731 9.10256 3.61514 9.02551C4.00298 8.94847 4.40498 8.98801 4.77031 9.13914C5.13565 9.29027 5.4479 9.5462 5.66759 9.87457C5.88729 10.2029 6.00455 10.589 6.00455 10.9839C6.00455 11.5135 5.7939 12.0214 5.41895 12.3958C5.044 12.7703 4.53546 12.9807 4.0052 12.9807ZM16.0013 18.971C15.6059 18.971 15.2193 18.8539 14.8905 18.6345C14.5617 18.4151 14.3055 18.1032 14.1541 17.7384C14.0028 17.3735 13.9632 16.972 14.0404 16.5847C14.1175 16.1973 14.3079 15.8416 14.5875 15.5623C14.8672 15.283 15.2234 15.0929 15.6112 15.0158C15.9991 14.9388 16.4011 14.9783 16.7664 15.1295C17.1318 15.2806 17.444 15.5365 17.6637 15.8649C17.8834 16.1932 18.0006 16.5793 18.0006 16.9742C18.0006 17.5038 17.79 18.0117 17.4151 18.3862C17.0401 18.7606 16.5316 18.971 16.0013 18.971Z",
            fill: color
        })
    });
};


/***/ }),

/***/ 28155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
// EXTERNAL MODULE: ./src/components/PageHeader/BackButton.tsx
var BackButton = __webpack_require__(1452);
// EXTERNAL MODULE: ./src/components/Icon/IconShare.tsx
var IconShare = __webpack_require__(94981);
;// CONCATENATED MODULE: ./src/components/PageHeader/ShareButton.tsx



const ShareButton = ({ size =24 , onShare  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: "#",
        className: "mr-0 ml-auto my-auto cursor-pointer",
        onClick: onShare,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconShare/* IconShare */.F, {
            size: size
        })
    });
};

// EXTERNAL MODULE: ./src/components/Icon/IconArrow.tsx
var IconArrow = __webpack_require__(16983);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(33906);
// EXTERNAL MODULE: ./src/modules/Auth/authHooks.ts
var authHooks = __webpack_require__(51615);
// EXTERNAL MODULE: ./src/components/Icon/IconFilter.tsx
var IconFilter = __webpack_require__(88038);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useSetState.js
var useSetState = __webpack_require__(69032);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(64078);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(86880);
// EXTERNAL MODULE: ./src/modules/Course/courseQuizStore.ts
var courseQuizStore = __webpack_require__(63106);
// EXTERNAL MODULE: ./src/modules/Course/courseAssignmentStore.ts
var courseAssignmentStore = __webpack_require__(49489);
;// CONCATENATED MODULE: ./src/components/PageHeader/PageHeader.tsx













const JoyRideNoSSR = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4337).then(__webpack_require__.bind(__webpack_require__, 4337)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(null /* weak dependency, without id */)
            ]
    },
    ssr: false
});
const PageHeader = (props)=>{
    const { isQuizOrIsAssignment =false , isLeaderboard =false , title , titleLesson =null , children , className ="" , titleClassName ="" , withBackButton , backTo , quizBackToCourse =false , assignmentBackToCourse =false , onShare , onBackClick , onFilter , withArrowButton  } = props;
    const router = (0,next_router.useRouter)();
    const { previousPath  } = (0,authHooks/* useRedirectPreviousPath */.$Z)();
    const { t  } = (0,useTranslation/* default */.Z)("tags");
    const { onCloseModal  } = (0,courseQuizStore/* useCourseQuizStore */.T)();
    const { onCloseModal: onCloseModalAssignment  } = (0,courseAssignmentStore/* useAssignmentStore */.i)();
    const onClickArrow = ()=>{
        if (backTo) {
            router.replace(backTo);
        } else if (quizBackToCourse) {
            onCloseModal(router);
        // (router as any).push(quizBackToCourse);
        } else if (assignmentBackToCourse) {
            onCloseModalAssignment(router);
        // (router as any).push(assignmentBackToCourse);
        } else {
            // If any trigger from my-class and user not logged in
            var isUsingLoginAuthorize = [
                "my-class"
            ].includes(previousPath);
            // Kursus terbaik tentang
            var isHomeUrl = previousPath === "home";
            router.push({
                pathname: isUsingLoginAuthorize || isHomeUrl ? "/" : previousPath
            });
        }
    };
    const [{ run , steps  }, setState] = (0,useSetState/* default */.Z)({
        run: false,
        steps: [
            {
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-b2 text-neutral-70 font-medium",
                            children: "Pasang filter sesuai kebutuhanmu"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-c1 text-neutral-70 font-light",
                            children: "Sekarang kamu bisa mencari kursus yang kamu butuhkan dengan filter"
                        })
                    ]
                }),
                floaterProps: {
                    disableAnimation: true
                },
                placement: "bottom-end",
                styles: {
                    options: {
                        width: 300,
                        zIndex: 1000
                    },
                    tooltipContent: {
                        padding: "unset"
                    }
                },
                offset: 1,
                spotlightPadding: 5,
                target: ".filter-popup",
                hideFooter: true,
                disableBeacon: true
            }
        ]
    });
    (0,react.useEffect)(()=>{
        const isClosedGuide = localStorage.getItem("isCloseGuide");
        if (onFilter && isClosedGuide) {
            setState({
                run: false
            });
        } else if (onFilter && !isClosedGuide) {
            localStorage.setItem("isCloseGuide", "true");
            setState({
                run: true
            });
        }
    }, []);
    const month = new Date().toLocaleString("default", {
        month: "long"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `z-10 h-60 px-16 flex items-center gap-16 border-b border-neutral20_to_dark30 sticky top-0 bg-white ${className}`,
        children: [
            onBackClick && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: onBackClick,
                className: "cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrow/* IconArrow */.C, {
                    size: 24
                })
            }),
            withBackButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton/* BackButton */.x, {
                backTo: ()=>router.back()
            }) : null,
            withArrowButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>router.back(),
                className: "cursor-pointer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconArrow/* IconArrow */.C, {
                    isCaret: true,
                    direction: "left",
                    color: "#000",
                    size: 24
                })
            }) : null,
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: `text-h4 font-medium ${titleClassName}`,
                children: t(title.toString())
            }) : null,
            isQuizOrIsAssignment && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: `text-h4 font-medium ${titleClassName}`,
                children: titleLesson
            }),
            isLeaderboard && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                className: `text-h4 font-medium ${titleClassName}`,
                children: [
                    month,
                    " Leaderboard"
                ]
            }),
            children ? children : null,
            onShare && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButton, {
                onShare: onShare
            }),
            onFilter && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JoyRideNoSSR, {
                        run: run,
                        steps: steps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: onFilter,
                        className: "filter-popup cursor-pointer my-auto mr-0 ml-auto rounded-md p-8 bg-light_neutral10_to_dark_neutral50",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFilter/* IconFilter */.w, {
                            color: "#2A1060"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 49489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useAssignmentStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79010);

const useAssignmentStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set, get)=>({
        // state
        userAnswer: null,
        isAssignmentDone: false,
        showAlertAssignment: false,
        localAnswers: {},
        isFinished: false,
        isRetakeAssignment: false,
        assignments: [],
        currentLesson: {},
        currentCourse: {},
        // actions
        setUserAnswer (userAnswer) {
            set((state)=>({
                    userAnswer: typeof userAnswer === "function" ? userAnswer(state.userAnswer) : userAnswer
                }));
        },
        setIsAssignmentDone (item) {
            set({
                isAssignmentDone: item
            });
        },
        setShowAlertAssignment (showAlertAssignment) {
            set((state)=>({
                    showAlertAssignment: typeof showAlertAssignment === "function" ? showAlertAssignment(state.showAlertAssignment) : showAlertAssignment
                }));
        },
        setLocalAnswers (localAnswers) {
            set((state)=>({
                    localAnswers: typeof localAnswers === "function" ? localAnswers(state.localAnswers) : localAnswers
                }));
        },
        setIsFinished (isFinished) {
            set((state)=>({
                    isFinished: typeof isFinished === "function" ? isFinished(state.isFinished) : isFinished
                }));
        },
        setIsRetakeAssignment (isRetakeAssignment) {
            set((state)=>({
                    isRetakeAssignment: typeof isRetakeAssignment === "function" ? isRetakeAssignment(state.isRetakeAssignment) : isRetakeAssignment
                }));
        },
        onCloseModal (router) {
            const { setIsFinished , setIsRetakeAssignment , localAnswers , setLocalAnswers , setShowAlertAssignment , assignments , currentCourse , currentLesson  } = get();
            if (localAnswers[assignments[0]?.id] == "" || Object.keys(localAnswers).length === 0) {
                setIsFinished(false);
                setIsRetakeAssignment(false);
                setLocalAnswers({});
                // TODO: onClose();
                router.push({
                    pathname: "/course/[courseSlug]",
                    query: {
                        courseSlug: currentCourse?.slug,
                        lesson: currentLesson?.slug
                    }
                });
            } else {
                setShowAlertAssignment(true);
            }
        },
        onCloseAlertAssignment (router) {
            const { setIsFinished , setIsRetakeAssignment , setLocalAnswers , currentCourse , currentLesson  } = get();
            setIsFinished(false);
            setIsRetakeAssignment(false);
            setLocalAnswers({});
            // TODO: onClose();
            router.push({
                pathname: "/course/[courseSlug]",
                query: {
                    courseSlug: currentCourse?.slug,
                    lesson: currentLesson?.slug
                }
            });
        },
        onResumeAssignment () {
            const { setShowAlertAssignment  } = get();
            setShowAlertAssignment(false);
        },
        setAssignments (item) {
            set({
                assignments: item
            });
        },
        setCurrentLesson (item) {
            set({
                currentLesson: item
            });
        },
        setCurrentCourse (item) {
            set({
                currentCourse: item
            });
        }
    }));


/***/ }),

/***/ 63106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useCourseQuizStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79010);

const useCourseQuizStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set, get)=>({
        // state
        isQuizDone: false,
        isTimeOut: false,
        step: 1,
        quizNumber: 0,
        isRetakeQuiz: false,
        showResults: false,
        quizScorePassedState: null,
        showAlertQuiz: false,
        currentLesson: {},
        currentCourse: {},
        runTimer: false,
        storeAnswers: [],
        showAnswerResult: false,
        isCorrect: false,
        multipleAnswerStatus: "default",
        // actions
        setIsQuizDone (item) {
            set({
                isQuizDone: item
            });
        },
        setIsTimeOut (item) {
            set({
                isTimeOut: item
            });
        },
        setStep (item) {
            set((state)=>({
                    step: typeof item === "function" ? item(state.step) : item
                }));
        },
        setNum (item) {
            set((state)=>({
                    quizNumber: typeof item === "function" ? item(state.quizNumber) : item
                }));
        },
        setIsRetakeQuiz (item) {
            set((state)=>({
                    isRetakeQuiz: typeof item === "function" ? item(state.isRetakeQuiz) : item
                }));
        },
        setShowResults (item) {
            set((state)=>({
                    showResults: typeof item === "function" ? item(state.showResults) : item
                }));
        },
        setQuizScorePassedState (item) {
            set({
                quizScorePassedState: item
            });
        },
        setCurrentLesson (item) {
            set({
                currentLesson: item
            });
        },
        setCurrentCourse (item) {
            set({
                currentCourse: item
            });
        },
        setShowAlertQuiz (item) {
            set((state)=>({
                    showAlertQuiz: typeof item === "function" ? item(state.showAlertQuiz) : item
                }));
        },
        onCloseModal (router) {
            const { setIsRetakeQuiz , setShowResults , setNum , step , setStep , quizScorePassedState , showResults , currentLesson , setShowAlertQuiz , currentCourse  } = get();
            if (step === 0 || step === 1 || step === 3) {
                setIsRetakeQuiz(false);
                setShowResults(false);
                setNum(0);
                // trackCloseBtn();
                if (quizScorePassedState && showResults) {
                    setStep(3);
                } else {
                    if (currentLesson?.duration) {
                        setStep(1);
                    }
                    setStep(2);
                }
                // TODO : onClose();
                router.push({
                    pathname: "/course/[courseSlug]",
                    query: {
                        courseSlug: currentCourse?.slug,
                        lesson: currentLesson?.slug
                    }
                });
            } else {
                setShowAlertQuiz(true);
            }
        },
        onCloseAlertQuiz (router) {
            const { setIsRetakeQuiz , setShowResults , setNum , setStep , quizScorePassedState , showResults , currentLesson , currentCourse  } = get();
            setIsRetakeQuiz(false);
            setShowResults(false);
            setNum(0);
            // trackCloseBtn();
            if (quizScorePassedState && showResults) {
                setStep(3);
            } else {
                if (currentLesson?.duration) {
                    setStep(1);
                }
                setStep(2);
            }
            // TODO : onClose();
            router.push({
                pathname: "/course/[courseSlug]",
                query: {
                    courseSlug: currentCourse?.slug,
                    lesson: currentLesson?.slug
                }
            });
        },
        onResumeQuiz () {
            const { setShowAlertQuiz  } = get();
            setShowAlertQuiz(false);
        },
        setRunTimer (item) {
            set({
                runTimer: item
            });
        },
        setStoreAnswers (item) {
            set((state)=>({
                    storeAnswers: typeof item === "function" ? item(state.storeAnswers) : item
                }));
        },
        setShowAnswerResult (item) {
            set({
                showAnswerResult: item
            });
        },
        setIsCorrect (item) {
            set({
                isCorrect: item
            });
        },
        setMultipleAnswerStatus (item) {
            set({
                multipleAnswerStatus: item
            });
        }
    }));


/***/ })

}]);